import { useLazyQuery } from "@apollo/client";
import { useEffect } from "react";
import { getEmpMasters } from "../queries/queries";
import { nodeVar } from "../utils/commonQueryTypes";

import { EmpMaster } from "../components/modules/asset/users/queries/types";

const useEmpMasters = (empId: number) => {
  const [GetEmp, { data }] = useLazyQuery<{ node: EmpMaster }, nodeVar>(
    getEmpMasters
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        GetEmp({
          variables: {
            id: empId,
          },
        });
      } catch (err) {
        console.error((err as Error).message);
      }
    };
    fetchData();
  }, [GetEmp, empId]);
  return {
    data,
  };
};

export default useEmpMasters;
